import ImageComparisonSlider from './ImageComparisonSlider'

export default ImageComparisonSlider
